import PropTypes from 'prop-types'
import './mybutton1.css'


export const MyButton1 = ({text, stylename, onClick}) => {
  
  return (
    <div>
      <button className = {stylename} type="button" onClick={onClick}>
        {text}
      </button>
    </div>
  )
}

MyButton1.defoltProps = {
  color: 'steelblue',
  stylename: 'mybutton1'
}

MyButton1.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  stylename:PropTypes.string,
  onClick: PropTypes.func
}
